import {call} from 'redux-saga/effects';
import {API, graphqlOperation} from 'aws-amplify';

export default (gql, variables) => call([API, 'graphql'], graphqlOperation(gql, variables));
